export const isRootDocument = (document: any) => document.root === document._id;
